<script setup lang="ts">
import { SelectValue, SelectContent, SelectItem, SelectItemText, SelectItemIndicator, SelectRoot, SelectTrigger } from "reka-ui";

const value = defineModel<string | number | null>();
defineProps<{
  label: string;
  options: { value: string | number | null; text: string }[];
}>();
</script>

<template>
  <div class="relative">
    <SelectRoot v-model="value" required>
      <SelectTrigger class="focus-default flex w-full items-center justify-center gap-1.5 rounded bg-light px-3 py-2">
        {{ label }}
        <SelectValue class="text-primary" />
      </SelectTrigger>
      <SelectContent position="popper" position-strategy="absolute" class="z-dropdown rounded-b bg-white shadow" align="end">
        <SelectItem v-for="(option, i) in options" :key="i" :value="option.value" :text-value="option.text" class="focus-default cursor-pointer px-3 py-1">
          <SelectItemText>
            {{ option.text }}
          </SelectItemText>
          <SelectItemIndicator />
        </SelectItem>
      </SelectContent>
    </SelectRoot>
  </div>
</template>
